// useVoiceTranscription.js
import { useEffect, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import {
  getTransciptionService,
  destroyTranscriptionService,
} from "../Transcription/TranscriptionService";

const useVoiceTranscription = (
  wsUrl,
  room,
  name,
  email,
  isMicActive,
  isTranscriptionEnabled
) => {
  const {
    TSstatus,
    isOwner,
    transcription,
    translation,
    detectedLang,
    targetLang,
    TSNotif,
    TSChecking,
    owner,
    transcriptionActive,
    sttLanguageOptions,
    translationLanguageOptions,
    sttSourceLang,
    translationTargetLang,
  } = useSelector((state) => state.transcription);

  const [transcriptionService, setTranscriptionService] = useState(null);
  const [showTranscriptionInfo, setShowTranscriptionInfo] = useState(false);

  useEffect(() => {
    if (!isTranscriptionEnabled) return undefined;

    const service = getTransciptionService(wsUrl, { name, email }, isMicActive);
    service.subscribeToWebscoketEvents();
    setTranscriptionService(service);

    return () => {
      destroyTranscriptionService();
      setTranscriptionService(null);
    };
  }, [wsUrl, name, email, isTranscriptionEnabled]);

   // Effect: Initialize Room and Service
  useEffect(() => {
    if (!isTranscriptionEnabled) return;
    if (room?.roomInfo?.name && transcriptionService) {
      transcriptionService.setRoom(room.roomInfo.name);
      transcriptionService.setLivekitRoom(room);
    }
  }, [room?.roomInfo?.name, transcriptionService, isTranscriptionEnabled, room]);

  // Effect: Handle Microphone State Changes
  useEffect(() => {
    if (!isTranscriptionEnabled) return;
    const service = getTransciptionService();
    if (service) {
      service.updateMicState(isMicActive);
    }
  }, [isMicActive, isTranscriptionEnabled]);
  // Public Method: Toggle Transcription
  const toggleTranscription = useCallback(() => {
  const service = getTransciptionService();
  if (!service) return;

  if (TSstatus === 'active') {
    service.stopTranscription();
    setShowTranscriptionInfo(true);
    setTimeout(() => setShowTranscriptionInfo(false), 5000);
  } else if (TSstatus === 'inactive') {
    service.activateTranscription();
  }
}, [TSstatus]);

  // Return Values for React Components
  return {
    TSstatus,
    isOwner,
    transcription,
    translation,
    detectedLang,
    targetLang,
    toggleTranscription,
    TSNotif,
    TSChecking,
    owner,
    transcriptionActive,
    showTranscriptionInfo,
    sttLanguageOptions,
    translationLanguageOptions,
    sttSourceLang,
    translationTargetLang,
  };
};

export default useVoiceTranscription;
